import z from "zod";

const translationPath =
  "page.register.digital_certificates.digitalCertificateFile.errors.";

export const digitalCertificateFileSchema = z
  .object({
    id: z.string().optional(),
    fileContent: z.instanceof(File, { message: translationPath + "file" }),
    filePassword: z.string().min(1, { message: translationPath + "password" }),
    initialDate: z.date({
      invalid_type_error: translationPath + "initial_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
  })
  .superRefine((val, ctx) => {
    if (val.endDate < val.initialDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["initialDate"],
        message: translationPath + "date",
      });
    }
  });

export type TDigitalCertificateFileForm = z.infer<
  typeof digitalCertificateFileSchema
>;
